// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Comment Settings ─── */

.comment-settings {
    max-width: 640px;
    margin: 0 auto;
}

/* ─── Platform Tabs ─── */
.cs-platform-tabs {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1.25rem;
    border-bottom: 2px solid #e2e8f0;
    padding-bottom: 0;
}

.cs-platform-tab {
    padding: 0.6rem 1.2rem;
    background: transparent;
    border: none;
    border-bottom: 3px solid transparent;
    color: #64748b;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    border-radius: 6px 6px 0 0;
}

.cs-platform-tab:hover {
    color: #1e293b;
    background: rgba(99, 102, 241, 0.08);
}

.cs-platform-tab.active {
    color: #4f46e5;
    border-bottom-color: #6366f1;
    background: rgba(99, 102, 241, 0.1);
}

/* ─── TikTok Business API Status Banner ─── */
.cs-business-status {
    padding: 0.85rem 1rem;
    border-radius: 10px;
    margin-bottom: 1.25rem;
    border: 1px solid;
}

.cs-business-status.connected {
    background: rgba(34, 197, 94, 0.1);
    border-color: rgba(34, 197, 94, 0.35);
}

.cs-business-status.disconnected {
    background: rgba(251, 191, 36, 0.12);
    border-color: rgba(217, 119, 6, 0.35);
}

.cs-business-info {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.cs-business-badge {
    font-size: 0.85rem;
    font-weight: 600;
    color: #15803d;
}

.cs-business-badge.warning {
    color: #b45309;
}

.cs-business-detail {
    font-size: 0.78rem;
    color: #475569;
    font-family: monospace;
}

.cs-business-hint {
    font-size: 0.8rem;
    color: #64748b;
    margin: 0;
    line-height: 1.4;
}

.cs-business-connect-btn {
    margin-top: 0.5rem;
    padding: 0.5rem 1.2rem;
    background: linear-gradient(135deg, #25f4ee, #fe2c55);
    border: none;
    border-radius: 8px;
    color: white;
    font-weight: 600;
    font-size: 0.85rem;
    cursor: pointer;
    transition: opacity 0.2s ease;
    align-self: flex-start;
}

.cs-business-connect-btn:hover {
    opacity: 0.9;
}

.cs-business-connect-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.comment-settings-loading,
.comment-settings-empty {
    text-align: center;
    padding: 3rem 1rem;
    color: #64748b;
}

.comment-settings-empty .empty-icon {
    display: block;
    font-size: 2.5rem;
    margin-bottom: 0.75rem;
}

.comment-settings-header {
    margin-bottom: 1.5rem;
}

.comment-settings-header h3 {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1e293b;
    margin: 0 0 0.25rem;
}

.comment-settings-subtitle {
    color: #64748b;
    font-size: 0.85rem;
    margin: 0;
}

/* ─── Field Group ─── */

.cs-field {
    background: #f8fafc;
    border: 1px solid rgba(99, 102, 241, 0.2);
    border-radius: 12px;
    padding: 1.25rem;
    margin-bottom: 1rem;
}

.cs-label {
    display: block;
    font-weight: 600;
    color: #1e293b;
    font-size: 0.95rem;
    margin-bottom: 0.15rem;
}

.cs-hint {
    display: block;
    color: #64748b;
    font-size: 0.8rem;
    margin-bottom: 0.75rem;
}

/* ─── Toggle Switch ─── */

.cs-toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
}

.cs-toggle-info {
    flex: 1 1;
}

.cs-toggle-info .cs-hint {
    margin-bottom: 0;
}

.cs-switch {
    position: relative;
    display: inline-block;
    width: 52px;
    height: 28px;
    flex-shrink: 0;
}

.cs-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.cs-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #cbd5e1;
    border-radius: 28px;
    transition: 0.3s;
}

.cs-slider::before {
    content: "";
    position: absolute;
    height: 22px;
    width: 22px;
    left: 3px;
    bottom: 3px;
    background: #fff;
    border-radius: 50%;
    transition: 0.3s;
}

.cs-switch input:checked+.cs-slider {
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
}

.cs-switch input:checked+.cs-slider::before {
    transform: translateX(24px);
}

/* ─── Tone Selector ─── */

.cs-tone-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    gap: 0.5rem;
}

.cs-tone-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    padding: 0.75rem 0.5rem;
    border: 2px solid #e2e8f0;
    border-radius: 10px;
    background: #ffffff;
    cursor: pointer;
    transition: all 0.2s;
    color: #475569;
}

.cs-tone-card:hover {
    border-color: rgba(99, 102, 241, 0.5);
    background: rgba(99, 102, 241, 0.06);
}

.cs-tone-card.selected {
    border-color: #6366f1;
    background: rgba(99, 102, 241, 0.1);
    color: #1e293b;
}

.cs-tone-icon {
    font-size: 1.5rem;
}

.cs-tone-label {
    font-size: 0.78rem;
    font-weight: 600;
}

.cs-tone-tagline {
    font-size: 0.68rem;
    color: #64748b;
    text-align: center;
    line-height: 1.3;
}

/* ─── Input / Textarea ─── */

.cs-input,
.cs-textarea {
    width: 100%;
    padding: 0.6rem 0.85rem;
    border-radius: 8px;
    border: 1px solid #cbd5e1;
    background: #ffffff;
    color: #1e293b;
    font-size: 0.9rem;
    outline: none;
    transition: border-color 0.2s;
    box-sizing: border-box;
}

.cs-input:focus,
.cs-textarea:focus {
    border-color: #6366f1;
}

.cs-textarea {
    resize: vertical;
    min-height: 70px;
    font-family: inherit;
}

/* ─── Actions ─── */

.cs-actions {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-top: 0.5rem;
}

.cs-save-btn {
    padding: 0.65rem 1.75rem;
    border: none;
    border-radius: 8px;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    color: #fff;
    font-weight: 600;
    font-size: 0.9rem;
    cursor: pointer;
    transition: opacity 0.2s;
}

.cs-save-btn:hover {
    opacity: 0.9;
}

.cs-save-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.cs-success-msg {
    color: #15803d;
    font-size: 0.85rem;
    font-weight: 500;
}

.cs-error-msg {
    color: #dc2626;
    font-size: 0.85rem;
    font-weight: 500;
}

/* ═══════════════════════════════════════════════
   Post Comments Modal — Light / Instagram Theme
   ═══════════════════════════════════════════════ */

.post-comments-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(6px);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
}

.post-comments-modal {
    background: #ffffff;
    border-radius: 16px;
    width: 100%;
    max-width: 540px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    border: 1px solid #efefef;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
    overflow: hidden;
}

/* ── Header ── */

.pcm-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.85rem 1.15rem;
    border-bottom: 1px solid #efefef;
}

.pcm-header h3 {
    margin: 0;
    color: #262626;
    font-size: 1rem;
    font-weight: 700;
}

.pcm-header-caption {
    font-weight: 400;
    font-size: 0.85rem;
    color: #8e8e8e;
}

.pcm-close-btn {
    background: none;
    border: none;
    color: #8e8e8e;
    font-size: 1.25rem;
    cursor: pointer;
    padding: 0.2rem;
    border-radius: 50%;
    transition: color 0.2s;
}

.pcm-close-btn:hover {
    color: #262626;
}

/* ── AI Pause Toggle ── */

.pcm-ai-toggle {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.55rem 1.15rem;
    border-bottom: 1px solid #efefef;
}

.pcm-ai-toggle-btn {
    padding: 0.3rem 0.75rem;
    border-radius: 8px;
    border: 1px solid #dbdbdb;
    background: #eafbf0;
    color: #1a8d48;
    font-size: 0.78rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
}

.pcm-ai-toggle-btn.paused {
    background: #fef2f2;
    color: #dc2626;
    border-color: #fecaca;
}

.pcm-ai-toggle-btn:hover {
    opacity: 0.85;
}

.pcm-ai-toggle-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.pcm-ai-status {
    font-size: 0.72rem;
    color: #8e8e8e;
}

/* ── New Comment Input ── */

.pcm-new-comment {
    display: flex;
    gap: 0.5rem;
    padding: 0.55rem 1.15rem;
    border-bottom: 1px solid #efefef;
}

/* ── Filter Chips ── */

.pcm-filters {
    display: flex;
    gap: 0.4rem;
    padding: 0.65rem 1.15rem;
    overflow-x: auto;
    border-bottom: 1px solid #efefef;
}

.pcm-filter-btn {
    padding: 0.3rem 0.7rem;
    border-radius: 20px;
    border: 1px solid #dbdbdb;
    background: transparent;
    color: #8e8e8e;
    font-size: 0.78rem;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s;
}

.pcm-filter-btn:hover {
    border-color: #8e8e8e;
    color: #262626;
}

.pcm-filter-btn.active {
    border-color: #262626;
    background: #262626;
    color: #ffffff;
}

/* ── Comment List ── */

.pcm-body {
    flex: 1 1;
    overflow-y: auto;
    padding: 0.5rem 1.15rem;
}

.pcm-empty {
    text-align: center;
    color: #8e8e8e;
    padding: 2.5rem 0;
    font-size: 0.9rem;
}

/* ── Single Comment Card ── */

.pcm-comment {
    padding: 0.75rem 0;
    border-bottom: 1px solid #efefef;
}

.pcm-comment:last-child {
    border-bottom: none;
}

.pcm-comment.owner-comment {
    background: #f0f4ff;
    border-radius: 10px;
    padding: 0.75rem 0.65rem;
    margin-bottom: 0.35rem;
    border-left: 3px solid #0095f6;
    border-bottom: none;
}

/* Avatar + Content flex row */

.pcm-comment-row {
    display: flex;
    gap: 0.7rem;
    align-items: flex-start;
}

/* ── Avatars ── */

.pcm-avatar {
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.78rem;
    font-weight: 700;
    color: #fff;
    background: linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045);
    flex-shrink: 0;
}

.pcm-avatar.owner {
    background: linear-gradient(135deg, #0095f6, #00d4ff);
}

.pcm-avatar.ai {
    width: 26px;
    height: 26px;
    min-width: 26px;
    font-size: 0.72rem;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
}

.pcm-comment-main {
    flex: 1 1;
    min-width: 0;
}

/* ── Comment Header ── */

.pcm-comment-header {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    flex-wrap: wrap;
    margin-bottom: 0.2rem;
}

.pcm-username {
    font-weight: 700;
    color: #262626;
    font-size: 0.84rem;
}

.pcm-owner-badge {
    display: inline-block;
    margin-left: 0.3rem;
    padding: 0.05rem 0.35rem;
    border-radius: 4px;
    background: #0095f6;
    color: #fff;
    font-size: 0.6rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
}

.pcm-sentiment-badge {
    font-size: 0.68rem;
    padding: 0.08rem 0.45rem;
    border-radius: 12px;
    font-weight: 600;
}

.pcm-sentiment-badge.positive {
    background: #eafbf0;
    color: #1a8d48;
}

.pcm-sentiment-badge.neutral {
    background: #f5f5f5;
    color: #8e8e8e;
}

.pcm-sentiment-badge.negative {
    background: #fef2f2;
    color: #dc2626;
}

.pcm-sentiment-badge.mixed {
    background: #fefce8;
    color: #b45309;
}

.pcm-time {
    font-size: 0.7rem;
    color: #8e8e8e;
    margin-left: auto;
}

/* ── Comment Text ── */

.pcm-comment-text {
    color: #262626;
    font-size: 0.87rem;
    line-height: 1.45;
    margin-bottom: 0.3rem;
}

/* ── User Message Bubble ── */

.pcm-user-message-bubble {
    background: #e8f4fd;
    border-radius: 12px;
    padding: 0.5rem 0.7rem;
    margin-bottom: 0.3rem;
    border-left: 3px solid #0095f6;
}

.pcm-user-message-text {
    font-size: 0.87rem;
    color: #262626;
    line-height: 1.45;
}

.pcm-no-content {
    font-style: italic;
    color: #8e8e8e;
    font-size: 0.82rem;
}

.pcm-user-message-bubble .pcm-likes {
    margin-top: 0.2rem;
    margin-bottom: 0;
}

.pcm-likes {
    font-size: 0.74rem;
    color: #8e8e8e;
    margin-bottom: 0.25rem;
}

/* ── Owner Actions ── */

.pcm-owner-actions {
    display: flex;
    gap: 0.5rem;
    margin-top: 0.3rem;
}

.pcm-action-btn {
    padding: 0.2rem 0.5rem;
    border-radius: 6px;
    border: 1px solid #dbdbdb;
    background: transparent;
    font-size: 0.72rem;
    cursor: pointer;
    transition: all 0.2s;
}

.pcm-action-btn.delete {
    color: #dc2626;
}

.pcm-action-btn.delete:hover {
    background: #fef2f2;
    border-color: #fecaca;
}

.pcm-action-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

/* ═════════════ Threaded AI Reply ═════════════ */

.pcm-ai-thread {
    position: relative;
    margin-top: 0.5rem;
    margin-left: 0.25rem;
    padding-left: 1rem;
}

.pcm-ai-thread::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 8px;
    width: 2px;
    background: #dbdbdb;
    border-radius: 2px;
}

.pcm-ai-reply-bubble {
    display: flex;
    gap: 0.5rem;
    align-items: flex-start;
}

.pcm-ai-reply-content {
    flex: 1 1;
    min-width: 0;
    background: #f5f5f5;
    border-radius: 12px;
    padding: 0.5rem 0.7rem;
}

.pcm-ai-reply-author {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.76rem;
    font-weight: 700;
    color: #6366f1;
    margin-bottom: 0.15rem;
}

.pcm-ai-reply-text {
    font-size: 0.84rem;
    color: #262626;
    line-height: 1.4;
}

/* ── Manual Reply Input ── */

.pcm-reply-row {
    display: flex;
    gap: 0.4rem;
    margin-top: 0.45rem;
}

.pcm-reply-input {
    flex: 1 1;
    padding: 0.4rem 0.65rem;
    border-radius: 20px;
    border: 1px solid #dbdbdb;
    background: #fafafa;
    color: #262626;
    font-size: 0.82rem;
    outline: none;
    transition: border-color 0.2s;
}

.pcm-reply-input::placeholder {
    color: #b0b0b0;
}

.pcm-reply-input:focus {
    border-color: #0095f6;
    background: #ffffff;
}

.pcm-reply-btn {
    padding: 0.4rem 0.8rem;
    border: none;
    border-radius: 20px;
    background: #0095f6;
    color: #fff;
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
    transition: opacity 0.2s;
    white-space: nowrap;
}

.pcm-reply-btn:hover {
    opacity: 0.85;
}

.pcm-reply-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

/* ── Comment Badge on Post Card ── */

.comment-count-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0.2rem 0.6rem;
    border-radius: 12px;
    background: rgba(99, 102, 241, 0.12);
    color: #4f46e5;
    font-size: 0.75rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
}

.comment-count-badge:hover {
    background: rgba(99, 102, 241, 0.22);
}

.comment-count-badge.fb {
    background: rgba(59, 89, 152, 0.12);
    color: #3b5998;
}

.comment-count-badge.fb:hover {
    background: rgba(59, 89, 152, 0.22);
}

/* ═══════════ Mobile: Bottom-Sheet Style ═══════════ */

@media (max-width: 640px) {
    .cs-tone-grid {
        grid-template-columns: repeat(3, 1fr);
    }

    .post-comments-overlay {
        align-items: flex-end;
        padding: 0;
    }

    .post-comments-modal {
        max-height: 92vh;
        border-radius: 16px 16px 0 0;
        max-width: 100%;
    }

    .pcm-avatar {
        width: 28px;
        height: 28px;
        min-width: 28px;
        font-size: 0.72rem;
    }

    .pcm-avatar.ai {
        width: 22px;
        height: 22px;
        min-width: 22px;
    }

    .pcm-comment-row {
        gap: 0.5rem;
    }

    .pcm-header {
        padding: 0.75rem 1rem;
    }

    .pcm-body {
        padding: 0.4rem 0.85rem;
    }

    .pcm-filters {
        padding: 0.5rem 0.85rem;
    }

    .pcm-username {
        font-size: 0.8rem;
    }

    .pcm-comment-text {
        font-size: 0.84rem;
    }

    .pcm-user-message-text {
        font-size: 0.84rem;
    }

    .pcm-user-message-bubble {
        padding: 0.4rem 0.55rem;
    }

    .pcm-ai-reply-content {
        padding: 0.4rem 0.55rem;
    }

    .pcm-ai-reply-text {
        font-size: 0.8rem;
    }
}

/* ─── Edit mode on owner comment bubble ─── */
.pcm-user-message-bubble.editing {
    background: #fff8e1;
    border: 1px solid #ffd54f;
    border-radius: 10px;
    padding: 0.55rem 0.7rem;
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
}

.pcm-edit-textarea {
    width: 100%;
    resize: vertical;
    padding: 0.45rem 0.55rem;
    font-family: inherit;
    font-size: 0.9rem;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    outline: none;
    box-sizing: border-box;
}

.pcm-edit-textarea:focus {
    border-color: #ffb300;
}

.pcm-edit-note {
    font-size: 0.72rem;
    color: #8a6d3b;
    font-style: italic;
}

.pcm-edit-actions {
    display: flex;
    gap: 0.4rem;
    justify-content: flex-end;
}

.pcm-moderate-action {
    margin-top: 0.3rem;
    display: flex;
    justify-content: flex-end;
}

.pcm-action-btn.moderate {
    background: transparent;
    color: #b0524a;
    border: 1px solid #e8c1be;
    font-size: 0.78rem;
    padding: 0.2rem 0.55rem;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.12s ease, color 0.12s ease;
}

.pcm-action-btn.moderate:hover:not(:disabled) {
    background: #c0392b;
    color: #fff;
    border-color: #c0392b;
}`, "",{"version":3,"sources":["webpack://./src/components/CommentSettings.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,oCAAoC;IACpC,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,mCAAmC;AACvC;;AAEA,8CAA8C;AAC9C;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,qDAAqD;IACrD,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;AACb;;AAEA,wBAAwB;;AAExB;IACI,mBAAmB;IACnB,yCAAyC;IACzC,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA,0BAA0B;;AAE1B;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,0BAA0B;;AAE1B;IACI,aAAa;IACb,4DAA4D;IAC5D,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,6BAA6B;;AAE7B;;IAEI,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA,oBAAoB;;AAEpB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;IACrD,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;oDAEoD;;AAEpD;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,0BAA0B;IAC1B,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA,iBAAiB;;AAEjB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA,0BAA0B;;AAE1B;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA,4BAA4B;;AAE5B;IACI,aAAa;IACb,WAAW;IACX,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA,uBAAuB;;AAEvB;IACI,aAAa;IACb,WAAW;IACX,wBAAwB;IACxB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA,uBAAuB;;AAEvB;IACI,SAAO;IACP,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,8BAA8B;;AAE9B;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;IACxB,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA,8BAA8B;;AAE9B;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;AAC3B;;AAEA,kBAAkB;;AAElB;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,8DAA8D;IAC9D,cAAc;AAClB;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,qDAAqD;AACzD;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA,yBAAyB;;AAEzB;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA,uBAAuB;;AAEvB;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA,8BAA8B;;AAE9B;IACI,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;AAC1B;;AAEA,wBAAwB;;AAExB;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA,kDAAkD;;AAElD;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA,6BAA6B;;AAE7B;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,qCAAqC;;AAErC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,oCAAoC;IACpC,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;AACvC;;AAEA,uDAAuD;;AAEvD;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,qBAAqB;QACrB,UAAU;IACd;;IAEA;QACI,gBAAgB;QAChB,4BAA4B;QAC5B,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,8CAA8C;AAC9C;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,wBAAwB;IACxB,oBAAoB;IACpB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,mDAAmD;AACvD;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB","sourcesContent":["/* ─── Comment Settings ─── */\n\n.comment-settings {\n    max-width: 640px;\n    margin: 0 auto;\n}\n\n/* ─── Platform Tabs ─── */\n.cs-platform-tabs {\n    display: flex;\n    gap: 0.5rem;\n    margin-bottom: 1.25rem;\n    border-bottom: 2px solid #e2e8f0;\n    padding-bottom: 0;\n}\n\n.cs-platform-tab {\n    padding: 0.6rem 1.2rem;\n    background: transparent;\n    border: none;\n    border-bottom: 3px solid transparent;\n    color: #64748b;\n    font-size: 0.9rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border-radius: 6px 6px 0 0;\n}\n\n.cs-platform-tab:hover {\n    color: #1e293b;\n    background: rgba(99, 102, 241, 0.08);\n}\n\n.cs-platform-tab.active {\n    color: #4f46e5;\n    border-bottom-color: #6366f1;\n    background: rgba(99, 102, 241, 0.1);\n}\n\n/* ─── TikTok Business API Status Banner ─── */\n.cs-business-status {\n    padding: 0.85rem 1rem;\n    border-radius: 10px;\n    margin-bottom: 1.25rem;\n    border: 1px solid;\n}\n\n.cs-business-status.connected {\n    background: rgba(34, 197, 94, 0.1);\n    border-color: rgba(34, 197, 94, 0.35);\n}\n\n.cs-business-status.disconnected {\n    background: rgba(251, 191, 36, 0.12);\n    border-color: rgba(217, 119, 6, 0.35);\n}\n\n.cs-business-info {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n}\n\n.cs-business-badge {\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: #15803d;\n}\n\n.cs-business-badge.warning {\n    color: #b45309;\n}\n\n.cs-business-detail {\n    font-size: 0.78rem;\n    color: #475569;\n    font-family: monospace;\n}\n\n.cs-business-hint {\n    font-size: 0.8rem;\n    color: #64748b;\n    margin: 0;\n    line-height: 1.4;\n}\n\n.cs-business-connect-btn {\n    margin-top: 0.5rem;\n    padding: 0.5rem 1.2rem;\n    background: linear-gradient(135deg, #25f4ee, #fe2c55);\n    border: none;\n    border-radius: 8px;\n    color: white;\n    font-weight: 600;\n    font-size: 0.85rem;\n    cursor: pointer;\n    transition: opacity 0.2s ease;\n    align-self: flex-start;\n}\n\n.cs-business-connect-btn:hover {\n    opacity: 0.9;\n}\n\n.cs-business-connect-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.comment-settings-loading,\n.comment-settings-empty {\n    text-align: center;\n    padding: 3rem 1rem;\n    color: #64748b;\n}\n\n.comment-settings-empty .empty-icon {\n    display: block;\n    font-size: 2.5rem;\n    margin-bottom: 0.75rem;\n}\n\n.comment-settings-header {\n    margin-bottom: 1.5rem;\n}\n\n.comment-settings-header h3 {\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #1e293b;\n    margin: 0 0 0.25rem;\n}\n\n.comment-settings-subtitle {\n    color: #64748b;\n    font-size: 0.85rem;\n    margin: 0;\n}\n\n/* ─── Field Group ─── */\n\n.cs-field {\n    background: #f8fafc;\n    border: 1px solid rgba(99, 102, 241, 0.2);\n    border-radius: 12px;\n    padding: 1.25rem;\n    margin-bottom: 1rem;\n}\n\n.cs-label {\n    display: block;\n    font-weight: 600;\n    color: #1e293b;\n    font-size: 0.95rem;\n    margin-bottom: 0.15rem;\n}\n\n.cs-hint {\n    display: block;\n    color: #64748b;\n    font-size: 0.8rem;\n    margin-bottom: 0.75rem;\n}\n\n/* ─── Toggle Switch ─── */\n\n.cs-toggle-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n}\n\n.cs-toggle-info {\n    flex: 1;\n}\n\n.cs-toggle-info .cs-hint {\n    margin-bottom: 0;\n}\n\n.cs-switch {\n    position: relative;\n    display: inline-block;\n    width: 52px;\n    height: 28px;\n    flex-shrink: 0;\n}\n\n.cs-switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.cs-slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #cbd5e1;\n    border-radius: 28px;\n    transition: 0.3s;\n}\n\n.cs-slider::before {\n    content: \"\";\n    position: absolute;\n    height: 22px;\n    width: 22px;\n    left: 3px;\n    bottom: 3px;\n    background: #fff;\n    border-radius: 50%;\n    transition: 0.3s;\n}\n\n.cs-switch input:checked+.cs-slider {\n    background: linear-gradient(135deg, #6366f1, #8b5cf6);\n}\n\n.cs-switch input:checked+.cs-slider::before {\n    transform: translateX(24px);\n}\n\n/* ─── Tone Selector ─── */\n\n.cs-tone-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\n    gap: 0.5rem;\n}\n\n.cs-tone-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.25rem;\n    padding: 0.75rem 0.5rem;\n    border: 2px solid #e2e8f0;\n    border-radius: 10px;\n    background: #ffffff;\n    cursor: pointer;\n    transition: all 0.2s;\n    color: #475569;\n}\n\n.cs-tone-card:hover {\n    border-color: rgba(99, 102, 241, 0.5);\n    background: rgba(99, 102, 241, 0.06);\n}\n\n.cs-tone-card.selected {\n    border-color: #6366f1;\n    background: rgba(99, 102, 241, 0.1);\n    color: #1e293b;\n}\n\n.cs-tone-icon {\n    font-size: 1.5rem;\n}\n\n.cs-tone-label {\n    font-size: 0.78rem;\n    font-weight: 600;\n}\n\n.cs-tone-tagline {\n    font-size: 0.68rem;\n    color: #64748b;\n    text-align: center;\n    line-height: 1.3;\n}\n\n/* ─── Input / Textarea ─── */\n\n.cs-input,\n.cs-textarea {\n    width: 100%;\n    padding: 0.6rem 0.85rem;\n    border-radius: 8px;\n    border: 1px solid #cbd5e1;\n    background: #ffffff;\n    color: #1e293b;\n    font-size: 0.9rem;\n    outline: none;\n    transition: border-color 0.2s;\n    box-sizing: border-box;\n}\n\n.cs-input:focus,\n.cs-textarea:focus {\n    border-color: #6366f1;\n}\n\n.cs-textarea {\n    resize: vertical;\n    min-height: 70px;\n    font-family: inherit;\n}\n\n/* ─── Actions ─── */\n\n.cs-actions {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    margin-top: 0.5rem;\n}\n\n.cs-save-btn {\n    padding: 0.65rem 1.75rem;\n    border: none;\n    border-radius: 8px;\n    background: linear-gradient(135deg, #6366f1, #8b5cf6);\n    color: #fff;\n    font-weight: 600;\n    font-size: 0.9rem;\n    cursor: pointer;\n    transition: opacity 0.2s;\n}\n\n.cs-save-btn:hover {\n    opacity: 0.9;\n}\n\n.cs-save-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.cs-success-msg {\n    color: #15803d;\n    font-size: 0.85rem;\n    font-weight: 500;\n}\n\n.cs-error-msg {\n    color: #dc2626;\n    font-size: 0.85rem;\n    font-weight: 500;\n}\n\n/* ═══════════════════════════════════════════════\n   Post Comments Modal — Light / Instagram Theme\n   ═══════════════════════════════════════════════ */\n\n.post-comments-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.45);\n    backdrop-filter: blur(6px);\n    z-index: 1000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 1rem;\n}\n\n.post-comments-modal {\n    background: #ffffff;\n    border-radius: 16px;\n    width: 100%;\n    max-width: 540px;\n    max-height: 85vh;\n    display: flex;\n    flex-direction: column;\n    border: 1px solid #efefef;\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);\n    overflow: hidden;\n}\n\n/* ── Header ── */\n\n.pcm-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.85rem 1.15rem;\n    border-bottom: 1px solid #efefef;\n}\n\n.pcm-header h3 {\n    margin: 0;\n    color: #262626;\n    font-size: 1rem;\n    font-weight: 700;\n}\n\n.pcm-header-caption {\n    font-weight: 400;\n    font-size: 0.85rem;\n    color: #8e8e8e;\n}\n\n.pcm-close-btn {\n    background: none;\n    border: none;\n    color: #8e8e8e;\n    font-size: 1.25rem;\n    cursor: pointer;\n    padding: 0.2rem;\n    border-radius: 50%;\n    transition: color 0.2s;\n}\n\n.pcm-close-btn:hover {\n    color: #262626;\n}\n\n/* ── AI Pause Toggle ── */\n\n.pcm-ai-toggle {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.55rem 1.15rem;\n    border-bottom: 1px solid #efefef;\n}\n\n.pcm-ai-toggle-btn {\n    padding: 0.3rem 0.75rem;\n    border-radius: 8px;\n    border: 1px solid #dbdbdb;\n    background: #eafbf0;\n    color: #1a8d48;\n    font-size: 0.78rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.pcm-ai-toggle-btn.paused {\n    background: #fef2f2;\n    color: #dc2626;\n    border-color: #fecaca;\n}\n\n.pcm-ai-toggle-btn:hover {\n    opacity: 0.85;\n}\n\n.pcm-ai-toggle-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.pcm-ai-status {\n    font-size: 0.72rem;\n    color: #8e8e8e;\n}\n\n/* ── New Comment Input ── */\n\n.pcm-new-comment {\n    display: flex;\n    gap: 0.5rem;\n    padding: 0.55rem 1.15rem;\n    border-bottom: 1px solid #efefef;\n}\n\n/* ── Filter Chips ── */\n\n.pcm-filters {\n    display: flex;\n    gap: 0.4rem;\n    padding: 0.65rem 1.15rem;\n    overflow-x: auto;\n    border-bottom: 1px solid #efefef;\n}\n\n.pcm-filter-btn {\n    padding: 0.3rem 0.7rem;\n    border-radius: 20px;\n    border: 1px solid #dbdbdb;\n    background: transparent;\n    color: #8e8e8e;\n    font-size: 0.78rem;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: all 0.2s;\n}\n\n.pcm-filter-btn:hover {\n    border-color: #8e8e8e;\n    color: #262626;\n}\n\n.pcm-filter-btn.active {\n    border-color: #262626;\n    background: #262626;\n    color: #ffffff;\n}\n\n/* ── Comment List ── */\n\n.pcm-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 0.5rem 1.15rem;\n}\n\n.pcm-empty {\n    text-align: center;\n    color: #8e8e8e;\n    padding: 2.5rem 0;\n    font-size: 0.9rem;\n}\n\n/* ── Single Comment Card ── */\n\n.pcm-comment {\n    padding: 0.75rem 0;\n    border-bottom: 1px solid #efefef;\n}\n\n.pcm-comment:last-child {\n    border-bottom: none;\n}\n\n.pcm-comment.owner-comment {\n    background: #f0f4ff;\n    border-radius: 10px;\n    padding: 0.75rem 0.65rem;\n    margin-bottom: 0.35rem;\n    border-left: 3px solid #0095f6;\n    border-bottom: none;\n}\n\n/* Avatar + Content flex row */\n\n.pcm-comment-row {\n    display: flex;\n    gap: 0.7rem;\n    align-items: flex-start;\n}\n\n/* ── Avatars ── */\n\n.pcm-avatar {\n    width: 32px;\n    height: 32px;\n    min-width: 32px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.78rem;\n    font-weight: 700;\n    color: #fff;\n    background: linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045);\n    flex-shrink: 0;\n}\n\n.pcm-avatar.owner {\n    background: linear-gradient(135deg, #0095f6, #00d4ff);\n}\n\n.pcm-avatar.ai {\n    width: 26px;\n    height: 26px;\n    min-width: 26px;\n    font-size: 0.72rem;\n    background: linear-gradient(135deg, #6366f1, #8b5cf6);\n}\n\n.pcm-comment-main {\n    flex: 1;\n    min-width: 0;\n}\n\n/* ── Comment Header ── */\n\n.pcm-comment-header {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    flex-wrap: wrap;\n    margin-bottom: 0.2rem;\n}\n\n.pcm-username {\n    font-weight: 700;\n    color: #262626;\n    font-size: 0.84rem;\n}\n\n.pcm-owner-badge {\n    display: inline-block;\n    margin-left: 0.3rem;\n    padding: 0.05rem 0.35rem;\n    border-radius: 4px;\n    background: #0095f6;\n    color: #fff;\n    font-size: 0.6rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n}\n\n.pcm-sentiment-badge {\n    font-size: 0.68rem;\n    padding: 0.08rem 0.45rem;\n    border-radius: 12px;\n    font-weight: 600;\n}\n\n.pcm-sentiment-badge.positive {\n    background: #eafbf0;\n    color: #1a8d48;\n}\n\n.pcm-sentiment-badge.neutral {\n    background: #f5f5f5;\n    color: #8e8e8e;\n}\n\n.pcm-sentiment-badge.negative {\n    background: #fef2f2;\n    color: #dc2626;\n}\n\n.pcm-sentiment-badge.mixed {\n    background: #fefce8;\n    color: #b45309;\n}\n\n.pcm-time {\n    font-size: 0.7rem;\n    color: #8e8e8e;\n    margin-left: auto;\n}\n\n/* ── Comment Text ── */\n\n.pcm-comment-text {\n    color: #262626;\n    font-size: 0.87rem;\n    line-height: 1.45;\n    margin-bottom: 0.3rem;\n}\n\n/* ── User Message Bubble ── */\n\n.pcm-user-message-bubble {\n    background: #e8f4fd;\n    border-radius: 12px;\n    padding: 0.5rem 0.7rem;\n    margin-bottom: 0.3rem;\n    border-left: 3px solid #0095f6;\n}\n\n.pcm-user-message-text {\n    font-size: 0.87rem;\n    color: #262626;\n    line-height: 1.45;\n}\n\n.pcm-no-content {\n    font-style: italic;\n    color: #8e8e8e;\n    font-size: 0.82rem;\n}\n\n.pcm-user-message-bubble .pcm-likes {\n    margin-top: 0.2rem;\n    margin-bottom: 0;\n}\n\n.pcm-likes {\n    font-size: 0.74rem;\n    color: #8e8e8e;\n    margin-bottom: 0.25rem;\n}\n\n/* ── Owner Actions ── */\n\n.pcm-owner-actions {\n    display: flex;\n    gap: 0.5rem;\n    margin-top: 0.3rem;\n}\n\n.pcm-action-btn {\n    padding: 0.2rem 0.5rem;\n    border-radius: 6px;\n    border: 1px solid #dbdbdb;\n    background: transparent;\n    font-size: 0.72rem;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.pcm-action-btn.delete {\n    color: #dc2626;\n}\n\n.pcm-action-btn.delete:hover {\n    background: #fef2f2;\n    border-color: #fecaca;\n}\n\n.pcm-action-btn:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n}\n\n/* ═════════════ Threaded AI Reply ═════════════ */\n\n.pcm-ai-thread {\n    position: relative;\n    margin-top: 0.5rem;\n    margin-left: 0.25rem;\n    padding-left: 1rem;\n}\n\n.pcm-ai-thread::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 8px;\n    width: 2px;\n    background: #dbdbdb;\n    border-radius: 2px;\n}\n\n.pcm-ai-reply-bubble {\n    display: flex;\n    gap: 0.5rem;\n    align-items: flex-start;\n}\n\n.pcm-ai-reply-content {\n    flex: 1;\n    min-width: 0;\n    background: #f5f5f5;\n    border-radius: 12px;\n    padding: 0.5rem 0.7rem;\n}\n\n.pcm-ai-reply-author {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    font-size: 0.76rem;\n    font-weight: 700;\n    color: #6366f1;\n    margin-bottom: 0.15rem;\n}\n\n.pcm-ai-reply-text {\n    font-size: 0.84rem;\n    color: #262626;\n    line-height: 1.4;\n}\n\n/* ── Manual Reply Input ── */\n\n.pcm-reply-row {\n    display: flex;\n    gap: 0.4rem;\n    margin-top: 0.45rem;\n}\n\n.pcm-reply-input {\n    flex: 1;\n    padding: 0.4rem 0.65rem;\n    border-radius: 20px;\n    border: 1px solid #dbdbdb;\n    background: #fafafa;\n    color: #262626;\n    font-size: 0.82rem;\n    outline: none;\n    transition: border-color 0.2s;\n}\n\n.pcm-reply-input::placeholder {\n    color: #b0b0b0;\n}\n\n.pcm-reply-input:focus {\n    border-color: #0095f6;\n    background: #ffffff;\n}\n\n.pcm-reply-btn {\n    padding: 0.4rem 0.8rem;\n    border: none;\n    border-radius: 20px;\n    background: #0095f6;\n    color: #fff;\n    font-size: 0.8rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: opacity 0.2s;\n    white-space: nowrap;\n}\n\n.pcm-reply-btn:hover {\n    opacity: 0.85;\n}\n\n.pcm-reply-btn:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n}\n\n/* ── Comment Badge on Post Card ── */\n\n.comment-count-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.3rem;\n    padding: 0.2rem 0.6rem;\n    border-radius: 12px;\n    background: rgba(99, 102, 241, 0.12);\n    color: #4f46e5;\n    font-size: 0.75rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.comment-count-badge:hover {\n    background: rgba(99, 102, 241, 0.22);\n}\n\n.comment-count-badge.fb {\n    background: rgba(59, 89, 152, 0.12);\n    color: #3b5998;\n}\n\n.comment-count-badge.fb:hover {\n    background: rgba(59, 89, 152, 0.22);\n}\n\n/* ═══════════ Mobile: Bottom-Sheet Style ═══════════ */\n\n@media (max-width: 640px) {\n    .cs-tone-grid {\n        grid-template-columns: repeat(3, 1fr);\n    }\n\n    .post-comments-overlay {\n        align-items: flex-end;\n        padding: 0;\n    }\n\n    .post-comments-modal {\n        max-height: 92vh;\n        border-radius: 16px 16px 0 0;\n        max-width: 100%;\n    }\n\n    .pcm-avatar {\n        width: 28px;\n        height: 28px;\n        min-width: 28px;\n        font-size: 0.72rem;\n    }\n\n    .pcm-avatar.ai {\n        width: 22px;\n        height: 22px;\n        min-width: 22px;\n    }\n\n    .pcm-comment-row {\n        gap: 0.5rem;\n    }\n\n    .pcm-header {\n        padding: 0.75rem 1rem;\n    }\n\n    .pcm-body {\n        padding: 0.4rem 0.85rem;\n    }\n\n    .pcm-filters {\n        padding: 0.5rem 0.85rem;\n    }\n\n    .pcm-username {\n        font-size: 0.8rem;\n    }\n\n    .pcm-comment-text {\n        font-size: 0.84rem;\n    }\n\n    .pcm-user-message-text {\n        font-size: 0.84rem;\n    }\n\n    .pcm-user-message-bubble {\n        padding: 0.4rem 0.55rem;\n    }\n\n    .pcm-ai-reply-content {\n        padding: 0.4rem 0.55rem;\n    }\n\n    .pcm-ai-reply-text {\n        font-size: 0.8rem;\n    }\n}\n\n/* ─── Edit mode on owner comment bubble ─── */\n.pcm-user-message-bubble.editing {\n    background: #fff8e1;\n    border: 1px solid #ffd54f;\n    border-radius: 10px;\n    padding: 0.55rem 0.7rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.45rem;\n}\n\n.pcm-edit-textarea {\n    width: 100%;\n    resize: vertical;\n    padding: 0.45rem 0.55rem;\n    font-family: inherit;\n    font-size: 0.9rem;\n    border: 1px solid #d9d9d9;\n    border-radius: 6px;\n    outline: none;\n    box-sizing: border-box;\n}\n\n.pcm-edit-textarea:focus {\n    border-color: #ffb300;\n}\n\n.pcm-edit-note {\n    font-size: 0.72rem;\n    color: #8a6d3b;\n    font-style: italic;\n}\n\n.pcm-edit-actions {\n    display: flex;\n    gap: 0.4rem;\n    justify-content: flex-end;\n}\n\n.pcm-moderate-action {\n    margin-top: 0.3rem;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.pcm-action-btn.moderate {\n    background: transparent;\n    color: #b0524a;\n    border: 1px solid #e8c1be;\n    font-size: 0.78rem;\n    padding: 0.2rem 0.55rem;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background 0.12s ease, color 0.12s ease;\n}\n\n.pcm-action-btn.moderate:hover:not(:disabled) {\n    background: #c0392b;\n    color: #fff;\n    border-color: #c0392b;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
